import { MaskedLine, Reveal } from "./Reveal";

export default function PageHeader({ overline, title, intro, testid }) {
  return (
    <header className="container-lux pt-36 pb-16 sm:pt-44 sm:pb-20" data-testid={testid}>
      <p className="overline-label">{overline}</p>
      <h1 className="mt-5 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.06] tracking-tight text-ink max-w-4xl">
        <MaskedLine delay={0.05}>{title[0]}</MaskedLine>
        <MaskedLine delay={0.18}>
          <span className="italic text-bronze">{title[1]}</span>
        </MaskedLine>
      </h1>
      {intro && (
        <Reveal delay={0.35}>
          <p className="mt-7 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-stone-warm">
            {intro}
          </p>
        </Reveal>
      )}
    </header>
  );
}
